var nurseslounge_job = {
    jobDetail:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_lounge_header.init($params, 'nurseslounge_job', 'jobDetail');
        nurseslounge_job.submenu($params, function(){
            $(".nav-underline a[data-id='jobDetail']").click();
        });
    },
    jobDetail_sub:function($params){
        nurseslounge_job_jobDetail.init($params);
    },
    submenu:function($params, cback){
        $(".nav-underline a").unbind().click(function(){
            $(".nav-underline a").removeClass('active');
            nurseslounge_job.submenu_open(this, $(this).data('url'),  $(this).data('id')+'_sub', $params)
        });
        nurseslounge_job.menu_selector();
        cback();
    },
    submenu_open:function($this, $url, $module, $params){
        $($this).addClass('active');
        router.pause();
        router.navigate($url);
        router.resume();
        $params = $.extend({}, $params, {user_id:libs.memoryGet('user_id')});
        libs.subrender($url, 'nurseslounge_job', $module, $params, 'POST');
    },
    menu_selector:function(){
        libs.globalUrl();
    }
};
